// import React from 'react'
import { useMemo } from "react";
import { RWebShare } from "react-web-share";
import styles from '../component/custom.module.css';


const style = {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    borderRadius: 3,
    border: 0,
    color: 'white',
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  };
  export default function RSSUsage() {
    const shareProps = useMemo(() => {
      return {
        title: document?.title,
        url: window.location?.href,
        text: 'Text message for sharing'
      }
    }, [])
    return (
      <div>
        <RWebShare
            data={shareProps}
            onClick={() => console.log("shared successfully!")}
          >
            <button className={styles.commonBtn}>Share it Now!</button>
          </RWebShare>
      </div>
    )
    // return <h1>Hello</h1>
  }